/**
 * The two waits the board can be in, and what it says about each.
 *
 * MissionsNode creates them and CellsSurface draws them, so the vocabulary lives in neither: a suite
 * that stubs the surface would otherwise take the tokens the node writes with it, and the node would
 * send `undefined` while every assertion about the sentence still passed.
 *
 * Each sentence names the thing being fetched rather than how far it has got — neither wait knows how
 * many of anything are coming, so a count would be a number the board cannot honour.
 */
export const LOADING_MISSIONS = 'missions';
export const LOADING_CELLS = 'cells';

const TEXT = {
  [LOADING_MISSIONS]: 'Loading missions…',
  [LOADING_CELLS]: "Loading the mission's cells…",
};

// An embedding that says it is loading without saying what it is loading still gets a spinner with a
// sentence; it just cannot be a specific one.
export const LOADING_FALLBACK = 'Loading…';

/** What to put in the board's status box for a wait token. */
export function loadingText(what) {
  return TEXT[what] || LOADING_FALLBACK;
}
